'use strict';

angular
    .module('App.v1.Controllers')
    .controller('App.v1.Directives.DeploymentNotification.Controller', 
        ["$scope", "$log",
            function($scope, $log) {
                var bootstrapModal = null;

                /**
                 * Initialize modal reference
                 */
                this.$onInit = function() {
                    var modalElement = document.getElementById('deploymentNotificationModal');
                    if (modalElement) {
                        bootstrapModal = $(modalElement);
                    }
                };

                /**
                 * Handle refresh button click
                 */
                $scope.refreshPage = function() {
                    window.location.reload();
                };

                /**
                 * Dismiss the notification
                 */
                $scope.dismissNotification = function() {
                    if (bootstrapModal) {
                        bootstrapModal.modal('hide');
                    }
                };

                /**
                 * Listen for deployment notification event
                 */
                $scope.$on('showDeploymentNotification', function(event, newVersion) {
                    $log.info("Deployment Notification: Showing notification for version: " + newVersion);
                    
                    if (bootstrapModal) {
                        bootstrapModal.modal('show');
                    }
                });
            }])
    .directive('appDeploymentNotification', function() {
        return {
            restrict: 'E',
            controller: 'App.v1.Directives.DeploymentNotification.Controller',
            template: `
                <div class="modal fade" id="deploymentNotificationModal" 
                     tabindex="-1" role="dialog" 
                     aria-labelledby="deploymentModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-info text-white">
                                <h5 class="modal-title" id="deploymentModalLabel">
                                    <i class="fas fa-sync-alt"></i> New Version Available
                                </h5>
                                <button type="button" class="close text-white" ng-click="dismissNotification()" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p>A new version of SnapDesk has been deployed. Please refresh the page to get the latest updates.</p>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" ng-click="dismissNotification()">
                                    Dismiss
                                </button>
                                <button type="button" class="btn btn-primary" ng-click="refreshPage()">
                                    <i class="fas fa-sync-alt"></i> Refresh Now
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            `
        };
    });
